import { render, staticRenderFns } from "./ContactType.vue?vue&type=template&id=b6ac748e&scoped=true&"
import script from "./ContactType.vue?vue&type=script&lang=js&"
export * from "./ContactType.vue?vue&type=script&lang=js&"
import style0 from "./ContactType.vue?vue&type=style&index=0&id=b6ac748e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ac748e",
  null
  
)

export default component.exports